module.exports = __webpack_public_path__ + "static/media/kjedelig.32c8066a.m4a";